
import { Prop, Vue } from "vue-property-decorator";

export default class Tirscript3TableBodyItemComponent extends Vue {
  @Prop({ type: Number, default: 0 }) col: number;
  @Prop({ type: Number, default: 0 }) row: number;
  @Prop({ type: Boolean, default: false }) sele: boolean;
  @Prop({ default: false }) borderLeft: boolean;
  @Prop({ default: false }) borderRight: boolean;
  @Prop({ default: false }) borderY: boolean;

  selectInner = false;
  mounted() {
    this.selectInner = this.sele;
  }
  ClickRow() {
    this.$emit("changeCol", this.row, this.col);
    this.$emit("on-click");
  }

  Emit() {
    this.$emit("on-click");
  }
}
